import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../layouts';
import configBase from '../../../../configBase';
import {verificaCache} from '../../../../verificaCache';
import axios from 'axios';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import {
  ScrollableTabsButtonAuto
} from './components';



class IncluirDependente extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      titlePage: '',
      detailsData: 'loading',
      detailsDataLoadingMsg: 'VALIDANDO A PROPOSTA...',
      showButtonS4: false,
      showButtonDelete: false,
      goPageList: false,

      modalConfirmOpen: false,
      modalConfirmQuestionContent: '',
      modalConfirmActionType: '',
      modalConfirmButton: '',
      modalConfirmButtonLoading: false,
      modalConfirmQuestion: false,

      errorRequest: false,
      msgErrorRequest: '',
      snackbarSuccess: false,
      msgSnackbarSuccess: '',

      fullScreenModal: false,

      countSend: 0,
      mensagemS4E: [],
      modalMensagemS4E: false,
      qtdErroEnvio: 0,
    };

    this.sexoLista = {
      0: 'FEMININO',
      1: 'MASCULINO'
    };

  }


  componentDidMount() {
    verificaCache(function (vc) {
      if (vc.erro === false) {
        this.beforeDetails();
        this.fullScreenModalFn();
      }
      else
        this.setError(vc.mensagem);
    }.bind(this));
  }

  fullScreenModalFn() {
    let width = document.getElementsByTagName('body')[0].offsetWidth;
    let state = this.state;

    if (width > 960)
      state.fullScreenModal = false;
    else
      state.fullScreenModal = true;

    this.setState(state);
  }

  beforeDetails() {
    let state = this.state;
    
    if (configBase.moduloDependentes === true) {
      let dependentesId = this.props.history.location.search.replace('?dp=', '');

      if (dependentesId && dependentesId.length > 0) {
        state.dependentesId = dependentesId;
        this.getDetails(dependentesId);
      }
      else {
        state.titlePage = '---';
        this.setError('Titular/Dependente é obrigatório', 'error');
      }
    }
    else {
      state.titlePage = '---';
      this.setError('Módulo de Gestão de Dependentes não habilitado.', 'error');
    }

    this.setState(state);
  }

  getDetails(dependentesId) {
    let url = configBase.api + 'InclusaoDependentes/'+dependentesId+'?access_token='+localStorage.getItem('planos_t');

    axios.get(url)
    .then((response) => {
      let state = this.state;
      state.titlePage = ' - '+response.data.titular;
      state.detailsData = response.data;
      state.detailsData.cpf = this.setMascCpf(response.data.cpf);
      this.setState(state);
      // Exibe ou não o campo de ação
      this.rulesOfActions(response.data);
    })
    .catch(function () {
      let state = this.state;
      state.detailsData = 'error';
      this.setState(state);
    }.bind(this));
  }

  rulesOfActions(titular) {
    let state = this.state;

    if (localStorage.getItem('planos_y') === 'REGISTER') {
      // Exibe botão do s4 e excluir
      if (titular.enviado === 'pendente') {
        state.showButtonS4 = true;
        state.showButtonDelete = true;
      }
      else {
        state.showButtonS4 = false;
        state.showButtonDelete = false;
      }
    }
    else if (localStorage.getItem('planos_y') === 'SALESMAN') {
      if (titular.enviado === 'pendente') {
        state.showButtonS4 = false;
        state.showButtonDelete = true;
      }
      else {
        state.showButtonS4 = false;
        state.showButtonDelete = false;
      }
    }

    this.setState(state);
  }

  formatoDatanascimento(data) {
    data = data.split('-');
    return data[2]+'/'+data[1]+'/'+data[0];
  }

  setError(msg, contentTable='error') {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    state.detailsData = contentTable;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  handleConfirmOpen(question, action, txtButton) {
    /*
    * @action pode ser: "delete", "activate"
    */

    let state = this.state;
    state.modalConfirmOpen = true;
    state.modalConfirmQuestionContent = question;
    state.modalConfirmQuestion = true;
    state.modalConfirmActionType = action;
    state.modalConfirmButton = txtButton;

    this.fullScreenModalFn();
  }

  handleConfirmClose () {
    let state = this.state;
    state.modalConfirmOpen = false;
    state.modalConfirmButtonLoading = false;
    this.setState(state);
  }

  actionsModal() {
    let state = this.state;
    state.modalConfirmQuestion = false;
    this.setState(state);
  }

  snackbarSuccessOpen(msg) {
    let state = this.state;
    state.snackbarSuccess = true;
    state.msgSnackbarSuccess = msg;
    this.setState(state);
  }

  snackbarSuccessClose() {
    let state = this.state;
    state.snackbarSuccess = false;
    state.msgSnackbarSuccess = '';
    this.setState(state);

    if (this.state.goPageList === true)
      this.goList();
  }

  sendS4() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    if (this.state.countSend < this.state.detailsData.dependentes.length) {
      let dep = this.state.detailsData.dependentes[this.state.countSend];

      axios.post(configBase.api + 'APIS4s/NovoDependente?access_token='+localStorage.getItem('planos_t'), dep)
      .then((res) => {
        let dataLog = {
          mensagem: res.data.mensagem,
          data: moment().format('DD/MM/YYYY HH:mm:ss'),
          titular: dep.codigoResponsavelFinanceiro,
        };

        // Salva log
        axios.post(configBase.api + 'logDependentes?access_token='+localStorage.getItem('planos_t'), dataLog)
        .then(() => {
          let state = this.state;
          state.countSend = state.countSend + 1;
          this.setState(state);

          if (res.data.codigo === 1) {
            this.setMensagemS4E(dep.dependente.nome + ' inserido(a) com sucesso!', true);
            this.sendS4();
          }
          else if (res.data.mensagem != null && res.data.mensagem.includes("Titular nao")) {
            this.setMensagemS4E('Não foi possível inserir ' + dep.dependente.nome +', titular não pode inserir dependentes no contrato, contate a '+configBase.empresaMiniscula+'!', false);
            this.sendS4();
          }
          else if (res.data.codigo === 3 && res.data.mensagem.includes("cadastrado e ativo no contrato")) {
            this.consultaAssociado(dep);
          }
          else if (res.data.mensagem.includes("Violation of PRIMARY KEY constraint")) {
            this.setMensagemS4E("Erro ao Inserir o depentende: " + dep.dependente.nome + " tente novamente", false);
            this.sendS4();
          }

        })
        .catch(() => {
          this.setMensagemS4E("Erro ao inserir Dependentes / Agregados no contrato, contate à administração do sistema!", false);
          this.sendS4();
        });// Fim logDependentes
      })
      .catch(() => {
        let state = this.state;
        state.modalConfirmButtonLoading = false;
        this.handleConfirmClose();
        this.setError('Problema encontrado ao efetivar cadastro', this.state.detailsData);
      });
    }
    else {
      // Caso não tenha erro, edita o titular
      if (this.state.qtdErroEnvio === 0) {
        let data = {
          enviado: 'atualizado',
          dataEnvio: moment().format('DD/MM/YYYY HH:mm:ss'),
        };

        axios.post(configBase.api + 'InclusaoDependentes/upsertWithWhere?where={"id":"'+this.state.detailsData.id+'"}&access_token='+localStorage.getItem('planos_t'), data)
        .then(() => {
          this.handleConfirmClose();
          let state = this.state;
          state.modalMensagemS4E = true;
          state.detailsData.enviado = 'atualizado';
          this.setState(state);
          this.rulesOfActions(this.state.detailsData);
        })
        .catch(() => {
          this.handleConfirmClose();
          this.setError('Problema encontrado ao efetivar cadastro', this.state.detailsData);
        });
      }
      else {
        this.handleConfirmClose();
        let state = this.state;
        state.modalMensagemS4E = true;
        this.setState(state);
      }
    }
  }

  handleMensagemS4EClose() {
    let state = this.state;
    state.modalMensagemS4E = false;
    state.countSend = 0;
    state.mensagemS4E = [];
    this.setState(state);
  }

  setMensagemS4E(msg, request=true) {
    let state = this.state;
    state.mensagemS4E.push(msg);

    if (request === false)
      state.qtdErroEnvio = state.qtdErroEnvio + 1;

    this.setState(state);
  }

  consultaAssociado(dep) {
    let data = {
      cpf: dep.dependente.cpf.replace(/\D/g, ''),
      empresa: 0,
      incluirDependentes: 1
    };

    axios.post(configBase.api + 'APIS4s/Associados?access_token='+localStorage.getItem('planos_t'), data)
    .then((res) => {
      if (res.data.Data.length > 0) {
        res.data.Data.forEach( (titular) => {
          if (titular.Dependente[0].Situacao === "1")
            this.setMensagemS4E(`${dep.dependente.nome} já possui cadastro ativo como Titular com o CPF : ${dep.dependente.cpf}`, false);
          else
            this.setMensagemS4E(`${dep.dependente.nome} já possui cadastro ativo no contrato com o CPF : ${dep.dependente.cpf}`, true);
        });
      }
      else {
        this.setMensagemS4E(`${dep.dependente.nome} já possui cadastro ativo no contrato com o CPF : ${dep.dependente.cpf}`, true);
      }

      this.sendS4();
    })
    .catch(() => {
      this.setMensagemS4E(`Erro ao Inserir o depentende ${dep.dependente.nome}  tente novamente`, false);
    });
  }

  setMascCpf(cpf) {
    if (cpf) {
      cpf = cpf.replace(/\D/g,"");
      cpf = cpf.replace(/(\d{3})(\d)/,"$1.$2");
      cpf = cpf.replace(/(\d{3})(\d)/,"$1.$2");
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
    }

    return cpf;
  }

  deleteProposal() {
    let state = this.state;
    state.modalConfirmButtonLoading = true;
    this.setState(state);

    axios.delete(configBase.api + 'InclusaoDependentes/'+this.state.dependentesId+'?access_token='+localStorage.getItem('planos_t'))
    .then(() => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      state.goPageList = true;
      state.disableButtons = true;
      state.detailsData = 'zero';

      this.handleConfirmClose();
      this.snackbarSuccessOpen('Excluída com sucesso');
    })
    .catch(() => {
      let state = this.state;
      state.modalConfirmButtonLoading = false;
      this.handleConfirmClose();
      this.setError('Houve um problema ao excluir', this.state.detailsData);
    });
  }

  goList() {
    this.props.history.push(`${process.env.PUBLIC_URL}/listadependentes`);
  }

  titular() {

    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Informações do Titular
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Contrato"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.contrato}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.titular}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Data de Nascimento"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.nascimento}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Sexo"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.sexo}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="CPF"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.cpf}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="RG"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.rg}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="TELEFONE"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.telefone}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="E-mail"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.email}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Endereço"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.rua}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  fullWidth
                  label="Nº"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.numero}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  label="Estado"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.estado}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Cidade"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.cidade}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Bairro"
                  type="text"
                  variant="outlined"
                  size="small"
                  value={this.state.detailsData.bairro}
                  disabled={true}
                />
              </Grid>

            </Grid>
          </div>
        </Paper>
      </div>
    );
  }

  beneficiarios() {
    return (
      <div>
        <Paper className="paperForm">
          <div className="paper">
            <Typography variant="h6" gutterBottom className="titlePaperForm">
              Dependentes
            </Typography>
          </div>

          <div>
            <Divider />
          </div>

          <div className="paper">
          {
            this.state.detailsData.dependentes.length === 0 ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={5} lg={5}>
                <MuiAlert severity="info" variant="filled" elevation={0}>
                  Sem dependentes cadastrados
                </MuiAlert>
              </Grid>
            </Grid>
            ) : (
              this.state.detailsData.dependentes.map((item, index) =>
              <Grid container spacing={2} style={{marginTop: 10}} key={index}>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Nº da Proposta"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.numeroProposta}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Código do Resp. Financeiro"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.codigoResponsavelFinanceiro}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Nome"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.nome}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Data Nascimento"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={this.formatoDatanascimento(item.dependente.dataNascimento)}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Parentesco"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.tipo}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Sexo"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={this.sexoLista[item.dependente.sexo]}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="CPF"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.cpf}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Mãe"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.nomeMae}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="E-mail"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.email}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Tel. Fixo"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.telefoneFixo}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Celular"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.celular}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Celular 2"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={item.dependente.celular2}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <TextField
                    fullWidth
                    label="Valor"
                    type="text"
                    variant="outlined"
                    size="small"
                    value={'R$ '+item.dependente.planoValor.replace('.', ',')}
                    disabled={true}
                  />
                </Grid>

                {
                  index + 1 < this.state.detailsData.dependentes.length ? (
                <div style={{width: '100%', margin: '15px 0px'}}>
                  <Divider />
                </div>
                  ) : ('')
                }
              </Grid>
              )
            )
          }


          </div>
        </Paper>
      </div>
    );
  }
  

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="resumoProposta" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  TITULAR {this.state.titlePage}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={8} className="barraBotao">

              {
                this.state.showButtonDelete === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: "#dc004e", color: "#fff", marginRight: 5}}
                    startIcon={<ClearIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'Será excluído titular e seus dependentes. Deseja continuar?', 'delete', 'SIM')}
                  >
                    EXCLUIR CADASTRO
                  </Button>
                </div>
                ) : ('')
              }
              {
                this.state.showButtonS4 === true ? (
                <div className="botoesDeEnvio">
                  <Button
                    variant="contained"
                    style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    startIcon={<AssignmentTurnedInIcon />}
                    size="small"
                    onClick={this.handleConfirmOpen.bind(this, 'O cadastro será ativada. Deseja continuar?', 'activate', 'SIM')}
                  >
                    ATIVAR CADASTRO
                  </Button>
                </div>
                ) : ('')
              }
              </Grid>
            </Grid>

          </Paper>

          <div id="resumoPropostaConteudo" className="contentepanel">
          {
          this.state.detailsData === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  {this.state.detailsDataLoadingMsg}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.detailsData === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                {
                    configBase.moduloDependentes === false ? (
                  <Alert severity="error">Módulo de Gestão de Dependentes não habilitado. Entre em contato com a Intelite Tecnologia</Alert>
                    ) : (
                  <Alert severity="error">Problema ao buscar dados do titular/dependentes</Alert>
                    )
                  }
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.detailsData === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">O titular e dependentes não foram encontrados</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
            <div id="resumoPropostaForm">
              <ScrollableTabsButtonAuto contentTabs={
                [
                  this.titular(),
                  this.beneficiarios(),
                ]
              } />
            </div>
              )
              )
            )
          }
          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.snackbarSuccess} autoHideDuration={5000} onClose={this.snackbarSuccessClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.snackbarSuccessClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSnackbarSuccess}
            </MuiAlert>
          </Snackbar>
        </div>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.modalConfirmOpen}
          onClose={this.handleConfirmClose.bind(this)}
          aria-labelledby="i_modalConfirm"
        >
          <DialogTitle id="i_modalConfirm">{"Confirmação"}</DialogTitle>
          <DialogContent>
            {/* Conteúdo para pergunta */
              this.state.modalConfirmQuestion === true ? (
            <DialogContentText>
              {this.state.modalConfirmQuestionContent}
            </DialogContentText>
              ) : (/* Conteúdo para cancelar */
                this.state.modalConfirmActionType === 'delete' ? (
            <DialogContentText>
              Os dados serão PERMANENTEMENTE excluídos. Para continuar, clique no botão EXCLUIR.
            </DialogContentText>
                ) : (
                  this.state.modalConfirmActionType === 'activate' ? (
            <DialogContentText>
              Caso o cadastro esteja revisada, aprovado e pronta para ser efetivado, clique no botão ATIVAR.
            </DialogContentText>
                  ) : ('')
                )
              )
            }
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary"
              onClick={this.handleConfirmClose.bind(this)}
            >
              Fechar
            </Button>

            {/* Botão para pergunta */
              this.state.modalConfirmQuestion === true ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.actionsModal.bind(this)}
              >
                {this.state.modalConfirmButton}
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
              ) : (/* Botão para cancelar */
                this.state.modalConfirmActionType === 'delete' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.deleteProposal.bind(this)}
              >
                EXCLUIR
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                ) : (
                  this.state.modalConfirmActionType === 'activate' ? (
            <div className="containerButton">
              <Button
                disabled={this.state.modalConfirmButtonLoading}
                color="primary"
                onClick={this.sendS4.bind(this)}
              >
                ATIVAR
              </Button>

              {
                this.state.modalConfirmButtonLoading === true ? (
              <CircularProgress size={24} className="progressButton" />
                ) : ('')
              }
            </div>
                  ) : ('')
                )
              )
            }

          </DialogActions>
        </Dialog>

        <Dialog
          fullScreen={this.state.fullScreenModal}
          open={this.state.modalMensagemS4E}
          onClose={this.handleMensagemS4EClose.bind(this)}
          aria-labelledby="i_modalMensagemS4E"
        >
          <DialogTitle id="i_modalMensagemS4E">{"Resultados dos Envios"}</DialogTitle>
          <DialogContent>
          {this.state.mensagemS4E.map((item, index) =>
            <DialogContentText key={index}>
              {item}<br/>
            </DialogContentText>
          )}
          </DialogContent>

          <DialogActions>
            <Button autoFocus color="primary"
              onClick={this.handleMensagemS4EClose.bind(this)}
            >
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </MainLayout>
    );

  }

}

IncluirDependente.propTypes = {
  history: PropTypes.object
};

export default withRouter(IncluirDependente);